import React from 'react';
import {
    CategoryBrowseProviderProps,
    CategoryBrowseProviders,
} from './CategoryBrowseProviders';
import { CategoryBrowseBasePage } from './pages/CategoryBrowseBasePage';
import { CategoryBrowsePage } from './pages/CategoryBrowsePage';

export const CategoryBrowsePageWithProviders: React.FunctionComponent<
    CategoryBrowseProviderProps
> = (props) => {
    return (
        <CategoryBrowseProviders
            match={props.match}
            location={props.location}
            history={props.history}
            location_data={props.location_data}
            location_slug={props.location_slug}
        >
            <CategoryBrowseBasePage {...props}>
                <CategoryBrowsePage />
            </CategoryBrowseBasePage>
        </CategoryBrowseProviders>
    );
};

export default CategoryBrowsePageWithProviders;
